import React from 'react';
import Translate from "../../../../../../../../components/Translate";
import {
    updateCompanyDeleteMessageConfigValue,
    updateCompanyEditLimitConfigValue,
    updateCompanyEditMessageConfigValue,
    updateCompanyMessageConfigDraftValue, updateCompanyReactMessageConfigValue,
    updateCompanyVoiceMessageConfigValue
} from "../../../../../../../../services/company/api";
import config from "../../../../../../../../config";
import Input from "../../../../../../../../components-new/form/Input";
import Switch from "../../../../../../../../components-new/form/Switch";
import SettingCard from "../../../../../../../../components-new/ui/SettingCard";

const validate = (value) => {
    const number = Number(value);

    if (!Number.isInteger(number) || number < -1 || number > 9999) {
        throw new Error('Value must be an integer between -1 and 9999');
    }
};

/**
 * Label on the left, switch at the end of the row.
 *
 * These are independent permissions, not one setting with a master switch, so
 * this card is the one place where a column of switches genuinely forms - and a
 * column is what makes "which of these are on" readable at a glance. The Switch
 * is a label element with the control first, so reversing the row keeps the whole
 * row clickable while putting the control at its end.
 */
const rowStyle = {
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    width: '100%'
};

const MessageConfig = ({client, messageConfigData, setMessageConfigData, features, isFetching}) => {

    const handleDraftCheckboxChange = (event) => {
        setMessageConfigData({...messageConfigData, operatorCanSeeDraft: event});
        updateCompanyMessageConfigDraftValue(client.id, event);
    };

    const handleEditCheckboxChange = (event) => {
        setMessageConfigData({...messageConfigData, operatorCanEditMessage: event});
        updateCompanyEditMessageConfigValue(client.id, event);
    };

    const handleDeleteCheckboxChange = (event) => {
        setMessageConfigData({...messageConfigData, operatorCanDeleteMessage: event});
        updateCompanyDeleteMessageConfigValue(client.id, event);
    };

    const handleReactCheckboxChange = (event) => {
        setMessageConfigData({...messageConfigData, operatorCanReactToMessage: event});
        updateCompanyReactMessageConfigValue(client.id, event);
    };

    const handleVoiceCheckboxChange = (event) => {
        setMessageConfigData({...messageConfigData, operatorCanSendVoiceMessage: event});
        updateCompanyVoiceMessageConfigValue(client.id, event);
    };

    const handleTimeInputChange = (newValue) => {
        setMessageConfigData({...messageConfigData, editLimit: newValue});
    }

    const handleTimeInputBlur = (newValue) => {
        updateCompanyEditLimitConfigValue(client.id, newValue);
    }

    return (
        <SettingCard titleKey="messageConfig">
            <div className="setting-switches" style={{opacity: isFetching ? 0.5 : 1}}>
                <Switch
                    checked={messageConfigData.operatorCanSendVoiceMessage !== false}
                    onChange={handleVoiceCheckboxChange}
                    label={<Translate text="operatorsCanSendVoiceMessage"/>}
                    style={rowStyle}
                    disabled={isFetching}
                />

                {features.includes(config.features.TYPING_MESSAGES_FOR_OPERATOR) && (
                    <Switch
                        checked={!!messageConfigData.operatorCanSeeDraft}
                        onChange={handleDraftCheckboxChange}
                        label={<Translate text="operatorsCanSeeDraftMessage"/>}
                        style={rowStyle}
                        disabled={isFetching}
                    />
                )}

                {features.includes(config.features.MESSAGE_REACTIONS) && (
                    <Switch
                        checked={!!messageConfigData.operatorCanReactToMessage}
                        onChange={handleReactCheckboxChange}
                        label={<Translate text="operatorsCanReactToMessage"/>}
                        style={rowStyle}
                        disabled={isFetching}
                    />
                )}

                {features.includes(config.features.MESSAGE_DELETE) && (
                    <Switch
                        checked={!!messageConfigData.operatorCanDeleteMessage}
                        onChange={handleDeleteCheckboxChange}
                        label={<Translate text="operatorsCanDeleteMessage"/>}
                        style={rowStyle}
                        disabled={isFetching}
                    />
                )}

                {features.includes(config.features.MESSAGE_EDIT) && (
                    <div>
                        <Switch
                            checked={!!messageConfigData.operatorCanEditMessage}
                            onChange={handleEditCheckboxChange}
                            label={<Translate text="operatorsCanEditMessage"/>}
                            style={rowStyle}
                            disabled={isFetching}
                        />

                        {/* the limit only exists while editing is allowed, so it
                            belongs under that row rather than as a fifth setting */}
                        {messageConfigData.operatorCanEditMessage && (
                            <div className="setting-subfield">
                                <p className="setting-hint"><Translate text="editLimitInfo"/></p>

                                <div className="setting-number">
                                    <div className="setting-number__box">
                                        <Input
                                            type={"number"}
                                            style={{
                                                width: '100%',
                                                border: 'none',
                                                height: '38px',
                                                background: 'transparent'
                                            }}
                                            value={messageConfigData.editLimit}
                                            validate={validate}
                                            onChange={(e) => handleTimeInputChange(e.target.value)}
                                            onBlur={(e) => handleTimeInputBlur(e.target.value)}
                                            disabled={isFetching}
                                        />
                                    </div>
                                    <span className="setting-number__unit"><Translate text={'min'}/></span>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </SettingCard>
    );
};

export default MessageConfig;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/functions/components/MessageConfig.jsx